import { render, staticRenderFns } from "./selectDrugModal.vue?vue&type=template&id=22266d82&scoped=true"
import script from "./selectDrugModal.vue?vue&type=script&lang=js"
export * from "./selectDrugModal.vue?vue&type=script&lang=js"
import style0 from "./selectDrugModal.vue?vue&type=style&index=0&id=22266d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22266d82",
  null
  
)

export default component.exports